<template xmlns:v-on="http://www.w3.org/1999/xhtml">
<div>
  <headlink></headlink>
  <div class="container ui-flex ui-flex-pack-center">
             
    <div class="right-container ui-center 	" >
      <ul class="ul-li-list " >
        <li  class="ui-border-b ui-flex  ui-flex-align-center ui-flex-pack-center">
          子用户设备列表    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <router-link :to="{ name:'dao', params: {uId:uid} }">
          	<button type="button" class="btn btn-primary">添加</button></router-link>
        </li>
      </ul>
    
     <ul class="ul-li-list " >
        <li v-for="eq in eqList"  v-on:click="addActive(eq.eqId)" class="ui-border-b ui-flex  ui-flex-align-center ui-flex-pack-center">
          <p>{{eq.eqName}}</p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<p>{{eq.eqId}}</p>
        </li>
      </ul>
      
    </div>
  </div>
  <div class="alert" v-show="alertFlag"  >
    <div class="dialog" >
      <div style="text-align: center;color:red;" >{{msg}}</div>
      <div style="padding: 20px;padding-bottom: 0; text-align: center;"  ><button class="btn-type" v-on:click="removeUser()">确定</button><button v-on:click="showWin(false)" class="btn-type btn-close" >取消</button></div>
    </div>
  </div>
</div>
</template>

<script>
import headlink from '@/components/common/headlink'

export default {
  name: 'fen',
  data () {
    return {
    	uid :"",
      eqId:"",
      eqList:{},
      alertFlag:false
    }
  },
  methods:{
   
 
    addActive:function(eqId){
      this.eqId = eqId;
      $(".ul-li-list li").removeClass("active");
      $("#"+eqId).addClass("active");
    }
  },
  mounted: function () {
    const history = window.sessionStorage;
//  var uid = history.getItem("user");
    var uid = this.$route.params.uId;
    this.uid=uid;
    this.$http.post('/ZYun/HttpService.do', {
      "serviceCode":"1012",
       "uId":uid

    })
      .then((response) => {
        if(response.data.respCode=="0000"){
          console.log(response)
          this.eqList = response.data.eqList;
          
        }else{
          console.log(response);
        }
      })
      .catch((response) =>{
        console.log(response);
      });
  },
  components: {
    headlink:headlink
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/index.css" >
</style>



// WEBPACK FOOTER //
// src/components/userManage/fen.vue